import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject
export class DictData {
  // æå¤§æææ¶é´ 30åé
  public static maxTimeInterval: number = 30 * 1000 * 1000;

  @JsonProperty('data', Object)
  public data: any = undefined;

  @JsonProperty('localTime', Number)
  public localTime: number = undefined;

  @JsonProperty('expired', Boolean)
  public expired: Boolean = false;

  constructor(data?: any) {
    this.data = data;
    this.localTime = new Date().getTime();
  }

  isTimeOut(): boolean {
    return new Date().getTime() - this.localTime > DictData.maxTimeInterval;
  }
}
